import { render, staticRenderFns } from "./integralOrder.vue?vue&type=template&id=0974fab1&scoped=true"
import script from "./integralOrder.vue?vue&type=script&lang=js"
export * from "./integralOrder.vue?vue&type=script&lang=js"
import style0 from "./integralOrder.vue?vue&type=style&index=0&id=0974fab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974fab1",
  null
  
)

export default component.exports